import appGlobalScript from 'C:/Users/EricSkelton/source/repos/sandbox/Stencil-Library/packages/stencil/unity-ambient-x/src/global/app.ts';
export const globalScripts = appGlobalScript;
